import { MouseEvent, KeyboardEvent } from 'react';

const INTERACTIVE_COMPONENTS_SELECTORS = [
    '[tabindex]',
    '[data-interactive]',
    'a',
    'button',
    'select',
    'textarea',
    'option',
    'input',
    '[role="button"]',
    '[role="tab"]',
    '[role="switch"]',
    '[role="checkbox"]',
    '[role="spinbutton"]',
    '[role="combobox"]',
    '[role="menuitem"]',
    '[role="menuitemcheckbox"]',
    '[role="menuitemradio"]',
].join(',');

export const isEventFromInteractiveComponent = (event: KeyboardEvent | MouseEvent): boolean => {
    const { target, currentTarget } = event;
    const closest = target instanceof Element && target.closest(INTERACTIVE_COMPONENTS_SELECTORS);
    return !!closest && closest !== currentTarget;
};
